const handleZipCode = (event) => {
  let input = event.target;
  input.value = zipCodeMask(input.value);
};

const zipCodeMask = (value) => {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{5})(\d)/, "$1-$2");
  return value;
};

const handleError = (hiddenClass, shownClass, errorText) => {
  handleLoader("shownLoader", "hiddenLoader");

  const errorSpan = document.querySelector(".hiddenError");

  if (errorSpan !== null) {
    errorSpan.classList.remove(hiddenClass);
    errorSpan.classList.add(shownClass);
    errorSpan.innerHTML = errorText;
  }
};

async function getCepData(cep) {
  const response = await fetch("https://viacep.com.br/ws/" + cep + "/json/");
  const data = await response.json();
  return data;
}

async function cartGetRates(country, state, zip) {
  return await fetch(
    "/cart/shipping_rates.json?" +
      new URLSearchParams({
        "shipping_address[country]": country,
        "shipping_address[province]": state,
        "shipping_address[zip]": zip,
      }).toString()
  )
    .then((response) => response.json())
    .catch(() => {
      handleError(
        "shownError",
        "hiddenError",
        "Erro ao calcular frete. Tente novamente mais tarde."
      );
    });
}

async function getCurrentProduct() {
  const url = `${window.location.pathname}.json`;

  const { product } = await fetch(url)
    .then((resp) => resp.json())
    .catch(() =>
      handleError(
        "shownError",
        "hiddenError",
        "Erro ao calcular frete. Tente novamente mais tarde."
      )
    );

  return product.variants[0].id;
}

async function mockCart(formData = {}) {
  if (Object.keys(formData).length !== 0) {
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .catch(() => {
        handleError(
          "hiddenError",
          "shownError",
          "Erro ao calcular frete. Tente novamente mais tarde."
        );
      });
  } else {
    await fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch(() => {
        handleError(
          "hiddenError",
          "shownError",
          "Erro ao calcular frete. Tente novamente mais tarde."
        );
      });
  }
}

function clearTable(table) {
  if (table !== null) {
    table.classList.add("hiddenTable");
    table.innerHTML = "";
  }
}

function populateTable(shipping_rates, table) {
  if (table !== null) {
    table.innerHTML = `
    <tr>
      <th>Entrega</th>
      <th>Frete</th>
      <th>Prazo</th>
    </tr>
    `;

    table.classList.remove("hiddenTable");

    if (shipping_rates.length === 0) {
      const newTR = document.createElement("tr");

      const html = `
          <td>Frete não disponível</td>
        `;

      newTR.innerHTML = html;

      table.appendChild(newTR);
    } else {
      shipping_rates.forEach((element) => {
        const newTR = document.createElement("tr");

        const brPrice = new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(element.price);

        const estimatedDate = new Date(element.delivery_date)
        const todaysDate = new Date()

        const differenceTime = estimatedDate.getTime() - todaysDate.getTime()

        const differenceDays = Math.round(differenceTime / (1000 * 3600 * 24))

        const html = `
            <td>${element.presentment_name}</td>
            <td>${brPrice}</td>
            <td>${differenceDays + 1} dias úteis</td>
          `;

        newTR.innerHTML = html;

        table.appendChild(newTR);
      });
    }
  }
}

function handleLoader(removedClass, shownClass) {
  const loader = document.querySelector(".loader");

  if (loader !== null) {
    loader.classList.remove(removedClass);
    loader.classList.add(shownClass);
  }
}

async function submitZipForm(zip, table) {
  handleLoader("hiddenLoader", "shownLoader");
  const productId = await getCurrentProduct();

  await mockCart({
    id: productId,
    quantity: 1,
  });

  const { uf } = await getCepData(zip);

  const { shipping_rates } = await cartGetRates("Brazil", uf, zip);

  handleLoader("shownLoader", "hiddenLoader");
  populateTable(shipping_rates, table);

  await mockCart();
}

document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("zip-code-input");
  const table = document.querySelector(".zipTable");
  const form = document.querySelector(".zipForm");

  if (input !== null) {
    input.addEventListener("keyup", (e) => {
      handleZipCode(e);

      if (input.value === "") {
        handleError("hiddenError", "shownError", "");
      }
    });
  }

  if (form !== null) {
    const button = form.querySelector("button");

    if (button !== null) {
      button.addEventListener("click", async () => {
        clearTable(table);

        input.value.length !== 9
          ? handleError("hiddenError", "shownError", "Insira um CEP valido.")
          : await submitZipForm(input.value, table);
      });
    }
  }
});
